<nz-modal
  [nzWidth]="'750px'"
  [(nzVisible)]="isVisible"
  (nzVisibleChange)="onIsVisibleChange($event)"
  [nzTitle]="undefined"
  (nzOnCancel)="onCancelClick()"
  [nzOkText]="null"
  [nzCancelText]="null"
  [nzClosable]="closable"
  [nzMaskClosable]="closable"
>
  <ng-container *nzModalContent>
    <div class="horizontal seperate body">
      <div class="vertical">
        <div class="title">{{ title }}</div>

        <div class="text">
          {{ content }}
        </div>

        <div class="additional">
          <ng-content></ng-content>
        </div>

        <div class="horizontal-large buttons">
          @if (okText) {
            <button nz-button nzType="primary" nzSize="large" (click)="onOkClick()">{{ okText }}</button>
          }

          @if (cancelText) {
            <button nz-button nzType="default" nzSize="large" (click)="onCancelClick()">{{ cancelText }}</button>
          }
        </div>
      </div>

      <img width="150px" [src]="imageSrc" />
    </div>
  </ng-container>
</nz-modal>
